














import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import DataContainer from "@common/modules/vuetifyx/common/DataContainer";
import VndTransactionDetailsTable from "./vnd-transactions/partials/VndTransactionDetailsTable.vue";

export default Vue.extend({
  components: { VndTransactionDetailsTable },
  data() {
    return {
      self: this,
      tableOptions: null,
    };
  },
  methods: {
    makeTableOptions() {
      return {
        attrs: {
          "item-key": "_id",
          "sort-by": "createdTime",
          "sort-desc": true,
          "show-expand": true,
        },
        content: {
          name: "Quản lý giao dịch VND",
          urlEnabled: true,
          search: {
            ext: {
              hidden: true,
            },
          },
          filters: {
            filters: {
              time: {
                type: "XDateTimePicker",
                rules: {
                  greater_than_or_equal_to: {
                    attrs: {
                      label: "Thời gian (bắt đầu)",
                      xOptions: {
                        content: {
                          resultFilter: (m) => m.startOf("day"),
                        },
                      },
                    },
                  },
                  less_than_or_equal_to: {
                    attrs: {
                      label: "Thời gian (kết thúc)",
                      xOptions: {
                        content: {
                          resultFilter: (m) => m.endOf("day"),
                        },
                      },
                    },
                  },
                },
              },
              amount: {
                type: "number",
                rules: {
                  greater_than_or_equal_to: {
                    attrs: {
                      label: "Số tiền thu (>=)",
                    },
                  },
                  less_than_or_equal_to: {
                    attrs: {
                      label: "Số tiền thu (<=)",
                    },
                  },
                },
              },
              paymentPartnerId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Đối tác",
                  "item-value": "_id",
                  "item-text": "name",
                  multiple: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call(
                          "paymentPartners",
                          "findAll",
                          {
                            payload: JSON.stringify({
                              search,
                              limit,
                              filters: [
                                {
                                  key: "_id",
                                  operator: "in",
                                  value,
                                },
                              ],
                            }),
                          },
                          undefined,
                          undefined,
                          "viewProtectedPage3"
                        );
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  in: {},
                },
              },
              paymentAccountId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Tài khoản ngân hàng",
                  "item-value": "_id",
                  "item-text": "name",
                  multiple: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call(
                          "paymentAccounts",
                          "findAll",
                          {
                            payload: JSON.stringify({
                              search,
                              limit,
                              filters: [
                                {
                                  key: "_id",
                                  operator: "in",
                                  value,
                                },
                              ],
                            }),
                          },
                          undefined,
                          undefined,
                          "viewProtectedPage3"
                        );
                        items.forEach((item) => {
                          item.name = `${item.name} - ${item.cardNumber} - ${item.bankName}`;
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  in: {},
                },
              },
              paymentReceiveAccountId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Tài khoản ngân hàng nhận tiền",
                  "item-value": "_id",
                  "item-text": "name",
                  multiple: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call(
                          "paymentReceiveAccounts",
                          "findAll",
                          {
                            payload: JSON.stringify({
                              search,
                              limit,
                              filters: [
                                {
                                  key: "_id",
                                  operator: "in",
                                  value,
                                },
                              ],
                            }),
                          },
                          undefined,
                          undefined,
                          "viewProtectedPage3"
                        );
                        items.forEach((item) => {
                          item.name = `${item.name} - ${item.cardNumber} - ${item.bankName}`;
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  in: {},
                },
              },
              marketId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Thị trường",
                  "item-value": "_id",
                  "item-text": "name",
                  multiple: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("markets", "findAll", {
                          payload: JSON.stringify({
                            search,
                            limit,
                            filters: [
                              {
                                key: "_id",
                                operator: "in",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  in: {},
                },
              },
              countryId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Quốc gia",
                  "item-value": "_id",
                  "item-text": "name",
                  multiple: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("countries", "findAll", {
                          payload: JSON.stringify({
                            search,
                            limit,
                            filters: [
                              {
                                key: "_id",
                                operator: "in",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  in: {},
                },
              },
            },
          },
          displayFields: {
            time: {
              text: "Thời gian",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            description: {
              text: "Mô tả",
            },
            amount: {
              text: "Số tiền thu",
              sortable: true,
              options: {
                filter: "number3",
              },
            },
            spentAmount: {
              text: "Số tiền chi",
              sortable: true,
              options: {
                filter: "number3",
              },
            },
            exchangeRate: {
              text: "Tỷ giá",
              sortable: true,
              options: {
                filter: "number3",
              },
            },
            paymentPartner: {
              text: "Đối tác",
              options: {
                label: true,
                subProp: "paymentPartner.name",
                sortBy: "paymentPartnerId",
              },
            },
            paymentAccount: {
              text: "TKNH",
              options: {
                label: true,
                sortBy: "paymentAccountId",
                preTransform(value) {
                  return `${value.name} - ${value.cardNumber} - ${value.bankName}`;
                },
              },
            },
            paymentReceiveAccount: {
              text: "TKNH nhận tiền",
              options: {
                label: true,
                sortBy: "paymentReceiveAccountId",
                preTransform(value) {
                  return value && `${value.name} - ${value.cardNumber} - ${value.bankName}`;
                },
              },
            },
            market: {
              text: "Thị trường",
              options: {
                label: true,
                subProp: "market.name",
                sortBy: "marketId",
              },
            },
            country: {
              text: "Quốc gia",
              options: {
                label: true,
                subProp: "country.name",
                sortBy: "countryId",
              },
            },
            action: {},
          },
          topActionButtons: {
            import: userManager.checkRole(["kt"]) && {
              attrs: {
                color: "default",
                dark: false,
              },
              content: {
                text: "Nhập Excel",
                icon: "mdi-upload",
              },
              target: {
                tooltip: { content: { text: "Nhập Excel" } },
                dialog: {
                  handlers: {
                    initialize() {
                      this.options.content.buttons.save.states.enabled = new DataContainer(false);
                    },
                  },
                  content: {
                    toolbar: {
                      title: "Nhập Excel",
                    },
                    content: {
                      type: "XForm",
                      makeAttrs(attrs, dialog) {
                        attrs.xModel = dialog.options.content.buttons.save.states.enabled;
                        attrs.xContext = dialog;
                        attrs.xData = new DataContainer({});
                        return attrs;
                      },
                      attrs: {
                        xOptions: {
                          content: {
                            sections: {
                              default: {
                                fields: {
                                  file: {
                                    type: "file",
                                    attrs: {
                                      label: "File",
                                      required: true,
                                    },
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                    buttons: {
                      save: {
                        content: {
                          text: "Tải lên",
                        },
                        states: {},
                        on: {
                          async xClick({ self }) {
                            const dialog = self.context();
                            const btn = dialog.context();
                            const dataTable = btn.context();
                            const form = dialog.contentContainer.value;
                            const data = form.getData();
                            self.loading.value = true;
                            const result = await dataTable.execute(
                              async () => {
                                return await coreApiClient.call("paymentVndTransactions", "import", {}, data, undefined, "viewProtectedPage3");
                              },
                              undefined,
                              {
                                disableLoading: true,
                                willRefresh: true,
                              }
                            );
                            self.loading.value = false;
                            if (result) {
                              const lines = [`Cập nhật thành công: ${result.updatedIndexes.length}`, "", `Các hàng bị lỗi ${result.errorIndexes.join(",")}`];
                              form.success.value = lines.join("<br/>");
                            }
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
            export: userManager.checkRole(["kt"]) && {
              attrs: {
                color: "default",
                dark: false,
              },
              content: {
                text: "Xuất Excel",
                icon: "mdi-microsoft-excel",
              },
              on: {
                xClick({ self }) {
                  const dataTable = self.context();
                  let findAllOptions = dataTable.getFindAllOptions();
                  if (dataTable.model.value.length) {
                    findAllOptions = {
                      payload: JSON.stringify({
                        filters: [
                          {
                            key: "_id",
                            operator: "in",
                            value: dataTable.model.value.map((item) => item._id),
                          },
                        ],
                        limit: -1,
                      }),
                    };
                  }
                  coreApiClient.download("paymentVndTransactions", `@/export`, findAllOptions);
                },
              },
            },
            insert: userManager.checkRole(["kt"]) && {},
          },
          template: {
            itemActionButtons: {
              edit: userManager.checkRole(["kt"]) && {
                target: {
                  dialog: {
                    ext: {
                      subTitleMaker: "description",
                    },
                  },
                },
              },
              delete: userManager.checkRole(["admin"]) && {},
            },
          },
          findAllOptionsFilter(options) {
            return options;
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const { items, count } = await coreApiClient.call("paymentVndTransactions", "findAll", options, undefined, undefined, "viewProtectedPage3");
              return [items, count];
            },
            async insert(item) {
              return await coreApiClient.call("paymentVndTransactions", "create", undefined, item, undefined, "viewProtectedPage3");
            },
            async update(item) {
              return await coreApiClient.call(
                "paymentVndTransactions",
                "update",
                {
                  id: item._id,
                },
                {
                  data: item,
                },
                undefined,
                "viewProtectedPage3"
              );
            },
            async delete(item) {
              return await coreApiClient.call(
                "paymentVndTransactions",
                "delete",
                {
                  id: item._id,
                },
                undefined,
                undefined,
                "viewProtectedPage3"
              );
            },
          },
          default: {
            defaultInputs: {
              description: {
                type: "textLarge",
                attrs: {
                  label: "Mô tả",
                },
              },
              time: {
                type: "XDateTimePicker",
                attrs: {
                  label: "Thời gian",
                },
              },
              amount: {
                type: "number",
                attrs: {
                  label: "Số tiền thu",
                },
              },
              spentAmount: {
                type: "number",
                attrs: {
                  label: "Số tiền chi",
                },
              },
              exchangeRate: {
                type: "number",
                attrs: {
                  label: "Tỷ giá",
                },
              },
              paymentPartnerId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Đối tác",
                  required: true,
                  "item-value": "_id",
                  "item-text": "name",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call(
                          "paymentPartners",
                          "findAll",
                          {
                            payload: JSON.stringify({
                              limit,
                              search,
                              filters: [
                                {
                                  key: "_id",
                                  operator: "equal_to",
                                  value,
                                },
                              ],
                            }),
                          },
                          undefined,
                          undefined,
                          "viewProtectedPage3"
                        );
                        return items;
                      },
                    },
                  },
                },
              },
              paymentAccountId: {
                type: "XAutocomplete",
                attrs: {
                  label: "TKNH",
                  required: true,
                  "item-value": "_id",
                  "item-text": "name",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call(
                          "paymentAccounts",
                          "findAll",
                          {
                            payload: JSON.stringify({
                              limit,
                              search,
                              filters: [
                                {
                                  key: "_id",
                                  operator: "equal_to",
                                  value,
                                },
                              ],
                            }),
                          },
                          undefined,
                          undefined,
                          "viewProtectedPage3"
                        );
                        items.forEach((item) => {
                          item.name = `${item.name} - ${item.cardNumber} - ${item.bankName}`;
                        });
                        return items;
                      },
                    },
                  },
                },
              },
              paymentReceiveAccountId: {
                type: "XAutocomplete",
                attrs: {
                  label: "TKNH nhận tiền",
                  required: true,
                  "item-value": "_id",
                  "item-text": "name",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call(
                          "paymentReceiveAccounts",
                          "findAll",
                          {
                            payload: JSON.stringify({
                              limit,
                              search,
                              filters: [
                                {
                                  key: "_id",
                                  operator: "equal_to",
                                  value,
                                },
                              ],
                            }),
                          },
                          undefined,
                          undefined,
                          "viewProtectedPage3"
                        );
                        items.forEach((item) => {
                          item.name = `${item.name} - ${item.cardNumber} - ${item.bankName}`;
                        });
                        return items;
                      },
                    },
                  },
                },
              },
              marketId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Thị trường",
                  "item-value": "_id",
                  "item-text": "name",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("markets", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
              },
              countryId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Quốc gia",
                  "item-value": "_id",
                  "item-text": "name",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("countries", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
              },
            },
            insertForm: {
              content: {
                fieldNames: ["time", "description", "amount", "spentAmount", "exchangeRate", "paymentPartnerId", "paymentReceiveAccountId", "marketId", "countryId"],
              },
            },
            editForm: {
              content: {
                fieldNames: ["time", "description", "amount", "spentAmount", "exchangeRate", "paymentPartnerId", "paymentReceiveAccountId", "marketId", "countryId"],
              },
            },
            delete: {
              confirmDisplayField: "description",
            },
          },
        },
      };
    },
  },
  async created() {
    this.tableOptions = this.makeTableOptions();
  },
});
